import { useEffect } from "react";
import { createContext } from "react";
import fetchIntercept from "fetch-intercept";
import { useHistory } from "react-router-dom";
import { useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setIsLoading(true);
    fetchIntercept.register({
      request: function (url, config) {
        const token = localStorage.getItem("jwt");
        if (token) {
          const cfg = config || {};
          cfg.headers = {
            ...(cfg.headers || {}),
            Authorization: `Bearer ${token}`,
          };
          return [url, cfg];
        }
        return [url, config];
      },

      requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
      },

      response: function (response) {
        if (response.status === 401 || response.status === 410) {
          alert("Sesión expirada");
          localStorage.clear();
          history.push("/");
        } else if (response.status === 403) {
          alert("No tienes permisos para realizar esta acción");
        } else {
          return response;
        }
      },

      responseError: function (error) {
        // Handle an fetch error
        return Promise.reject(error);
      },
    });
    setIsLoading(false);
  }, [history]);

  return (
    <AuthContext.Provider value={{}}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};
